import SettingsPage from './components/SettingsPage';

const routes = [
  {
    path: '/settings',
    name: 'menu.settings',
    icon: 'sliders2',
    loginRequired: true,
    component: SettingsPage,
    weight: 999,
    permission: [],
    children: [],
    forMobile: false,
  },
];

export default routes;
